import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BroadcastMessageService } from '@app/services/broadcast/change-organization/broadcast-message.service';
import { BroadcastMessageType } from '@app/services/broadcast/change-organization/broadcastMessage.model';
import { ModalService } from '@app/services/modal.service';
import { CoralogixService } from '@app/services/coralogix.service';
import { PartnerService } from '@core/services/partners/partner.service';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { ToasterConfig } from 'angular2-toaster';
import { Observable } from 'rxjs';
import { ModalItem } from './components/modals/modal-item';
import { PostMessageService } from './services/postMessage.service';
import { RouterService } from '@app/services/router.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
	public toasterConfig: ToasterConfig = new ToasterConfig({ timeout: 7000 });
	public modals$: Observable<Array<ModalItem<any>>> = this.modalService.modals$;

	constructor(
		private readonly broadcastService: BroadcastMessageService,
		private readonly partnerService: PartnerService,
		private readonly modalService: ModalService,
		private readonly coralogixService: CoralogixService,
		private readonly router: Router,
		private postMessageService: PostMessageService,
		private routerService: RouterService,
	) {
		this.router.resetConfig(this.routerService.getAppRoutes());
		this.router.initialNavigation();
	}

	public ngOnInit(): void {
		this.postMessageService.init();
		this.partnerService.init();
		this.subscribeToBroadcastChanges();
		this.coralogixService.init();
	}

	private subscribeToBroadcastChanges(): void {
		this.broadcastService.selectMessagesByType(BroadcastMessageType.organizationChanged).subscribe(async (res) => {
			if (res?.type === BroadcastMessageType.organizationChanged) {
				try {
					const navigateSuccess: boolean = await this.router.navigate([AppRouteHelper.defaultRoute]);
					if (navigateSuccess) {
						setTimeout(() => globalThis.location?.reload(), 500);
					}
				} catch (error) {
					globalThis.location?.reload();
				}
			}
		});
	}
}
